import { t } from '@deltasierra/shared';

export function buildClubNameWithCountString(clubName: string, clubCount: number): string {
    return clubCount <= 1
        ? clubName
        : `${clubName} + ${t('BUILD.PUBLISH.CLUB_READY.MORE_CLUB_COUNT', { count: clubCount - 1 })}`;
}
